export default __webpack_public_path__ + "static/media/joystick@2x.8081b581.png";